import React, { useEffect, useState } from 'react';
import { PagingQuery, Button } from 'tea-component';
import Filter from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/Sizer/PCUDetailFilter';
import { useIntl, connect } from 'umi';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { updateDefaultTimeParams } from '@/pages/intelligence/pages/TopCharts/_config/detailDefaltfilterTime';
import GamesCard from './GamesCard';
import { getPCUGamesCardData } from './_utils';
import { useCompanyOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useCompanyOptionList';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { changeTimetoDay } from '@/pages/intelligence/utils/topchartsUtils';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import DetailDownload from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/DetailDownload';
import { COMBINEID_REG } from '@intelligence/utils/constant';

const GamesStatsPCU = (porps: any) => {
  const {
    tabId,
    filterState,
    companyId,
    entityType,
    setMainLoading,
    mainLoading,
    setDownloadParamsNormal,
    downloadParamsNormal,
    gameName,
  } = porps;
  const { formatMessage } = useIntl(); // 中英切换方法

  const { isOperateDetail, detailFilterExtend } = useFilterExtend({});
  const [gameTableLoading, setGameTableLoading] = useState(false);
  const [gameChartLoading, setGameChartLoading] = useState(true);
  const [gameChartType, setGameChartType] = useState<string>('line');
  const [gameTotal, setGameTotal] = useState<number>(0);
  const [gameTableList, setGameTableList] = useState<any>([]);
  const [gameLineList, setGameLineList] = useState<any>([]);
  const [gameCardStats, setGameCardStats] = useState<any>({
    isLoading: true,
    isError: false,
    isNoData: true,
  });
  const { companyPCUList } = useCompanyOptionList();

  const [fetchParams, setFetchParams] = useState({
    company_id: companyId,
    entity_type: entityType,
    data_sources: ['steamcharts'],
    order_metric: 'pcu',
    order: 'desc',
    page: 1,
    page_size: 5,
    metrics: ['pcu', 'acu'],
    region_type: 'region', // 目前固定
    regions: [
      // 目前固定
      'global',
    ],
    period: 'day',
    start_date: '',
    end_date: '',
  });

  useEffect(() => {
    if (companyId) {
      let newFetchParams = {
        ...fetchParams,
      };
      if (isOperateDetail === true) {
        /** 获取继承参数 */
        const extendParams = getExtendParams();
        newFetchParams = { ...newFetchParams, ...extendParams };
      }
      setFetchParams(newFetchParams);
      getGamesCardData(newFetchParams);
    }
  }, [companyId]);

  const getExtendParams = () => {
    const newFetchParams: any = {};
    const timeExtend = detailFilterExtend[filterKeyMap.RANGE_TIME];
    newFetchParams.period = changeTimetoDay(timeExtend?.granularity);
    newFetchParams.start_date = timeExtend?.start_date || '';
    newFetchParams.end_date = timeExtend?.end_date || '';
    return newFetchParams;
  };

  const getGamesCardData = async (params) => {
    // 添加ID校验规则
    if (COMBINEID_REG.test(companyId)) {
      setGameCardStats({
        ...gameCardStats,
        isLoading: true,
      });
      setMainLoading(true);
      setDownloadParamsNormal(params);
      const gameData = await getPCUGamesCardData(params, tabId);
      const { startDate, endDate, cardStats, lineData, tableData, total } = gameData;
      setDownloadParamsNormal({
        ...params,
        start_date: startDate,
        end_date: endDate,
      });
      setGameCardStats(cardStats);
      setGameLineList(lineData);
      setGameTableList(tableData);
      setGameTotal(total);
      const updatedFetchParams: any = updateDefaultTimeParams({
        fetchParams: params,
        startDate,
        endDate,
        period: params.period,
        isTwoMonths: false,
      });
      setFetchParams(updatedFetchParams);
      setMainLoading(false);
    }
  };

  const onGameTableSortChage = async (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.ratioType === 1 ? `${e?.sortMetric}_ratio` : e?.sortMetric,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const gameData = await getPCUGamesCardData(newFetchParams, tabId);
    const { tableData } = gameData;
    setGameTableList(tableData);
    setGameTableLoading(false);
  };

  const onGameTablePagingChange = async (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 5,
    };
    setGameTableList([]);
    setGameTableLoading(true);
    const gameData = await getPCUGamesCardData(newFetchParams, tabId);
    const { tableData } = gameData;
    setGameTableList(tableData);
    setGameTableLoading(false);
  };

  const handleConfirm = (value: any) => {
    const newFetchParams = {
      ...fetchParams,
      start_date: value?.start_date,
      end_date: value?.end_date,
      period: changeTimetoDay(value?.date_type),
    };
    getGamesCardData(newFetchParams);
  };

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          <Filter
            timeFilterValues={{
              type: fetchParams.period,
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            buttonLogConfig={{}}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            filterInit={() => {}}
          />
          <span className="dbi-statsfilter-warp-left-text">
            {formatMessage({ id: 'dbi_global_only' })}
          </span>
        </div>
        <div className="dbi-statsfilter-warp-right">
          <DetailDownload
            entityType={entityType}
            mainLoading={mainLoading}
            downloadParamsNormal={downloadParamsNormal}
            gameName={gameName}
            segpaVa={entityType}
            segment={'pcu'}
          />
        </div>
      </div>
      <GamesCard
        lineData={gameLineList}
        tableData={gameTableList}
        dateType={fetchParams?.period}
        cardStatus={gameCardStats}
        tableTotal={gameTotal}
        columnsList={companyPCUList}
        tableLoading={gameTableLoading}
        onTableSortChage={onGameTableSortChage}
        onTablePagingChange={onGameTablePagingChange}
        entityType={entityType}
        setChartLoading={setGameChartLoading}
        chartLoading={gameChartLoading}
        tabId={tabId}
        chartType={gameChartType}
        setChartType={setGameChartType}
      />
    </>
  );
};
export default connect((state: any) => {
  return {
    filterState: state[FILTER_EXTEND_NAMESPACE],
    topchartsState: state[DBI_TOPCHARTS],
  };
})(GamesStatsPCU);
